import { CELL_FOCUS, CELL_BLUR, CELL_BLUR_ALL } from '../../actions/cell';
export var focus = function (state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case CELL_FOCUS: {
            return {
                nodeId: action.id,
                source: action.source,
                scrollToCell: action.scrollToCell ? new Date().getTime() : null,
            };
        }
        case CELL_BLUR_ALL:
            return null;
        case CELL_BLUR:
            return action.id === (state === null || state === void 0 ? void 0 : state.nodeId) ? null : state;
        default:
            return state;
    }
};
//# sourceMappingURL=index.js.map